<footer
  class="border-t border-gray-800 py-8 bg-gray-900 fs-condensed"
  lang="es-HN"
>
  <div class="container mx-auto px-4 md:px-2">
    <div class="flex flex-col md:flex-row items-center justify-between">
      <!-- Copyright Section -->
      <div class="flex gap-2 items-center">
        <div class="text-gray-400 text-xs xl:text-sm mb-4 md:mb-0">
          © {{ currentYear }} ALLAS REPUESTOS Honduras. Todos los derechos
          reservados.
        </div>
      </div>

      <!-- Links and Apps Section -->
      <div class="flex flex-wrap gap-8 text-xs xl:text-sm items-center">
        <!-- Sitemap Link -->
        <a
          href="/sitemap"
          class="text-gray-400 hover:text-white transition-colors"
          aria-label="Ver mapa del sitio web"
        >
          Mapa del Sitio
        </a>

        <!-- Legal Links -->
        @for(link of legal; track link.name) {
        <ng-container
          [ngTemplateOutlet]="legalLinkTemplate"
          [ngTemplateOutletContext]="{ link: link }"
        ></ng-container>
        }

        <!-- App Store Links -->
        <ng-container *ngTemplateOutlet="appStoreLinksTemplate"></ng-container>

        <!-- Duns Qr Code -->
        <div class="flex gap-2 items-center">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXqKGgcOldsveZ7zv4yr-8DU-CME0aQ1wzmg&s"
            alt="D-U-N-S Registered Seal"
            height="40"
            class="h-10 w-auto"
          />
          <img
            src="https://api.qrserver.com/v1/create-qr-code/?size=40x40&data=https://dunsregistered.dnb.com/profile/850654864"
            alt="QR DUNS"
          />
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- Legal Link Template -->
<ng-template #legalLinkTemplate let-link="link">
  <a
    [href]="link.href"
    class="text-gray-400 hover:text-white transition-colors text-xs xl:text-sm"
    [attr.aria-label]="'Ver ' + link.name"
  >
    {{ link.name }}
  </a>
</ng-template>

<!-- App Store Links Template -->
<ng-template #appStoreLinksTemplate>
  <span
    class="gap-2 hidden xl:flex"
    role="group"
    aria-label="Enlaces a tiendas de aplicaciones"
  >
    <a
      href="https://apps.apple.com/hn/app/allas-repuestos-bater%C3%ADas/id6752626505?l=en-GB"
      aria-label="Descargar aplicación desde Apple Store"
    >
      <img
        src="/allas-icons/app_store.svg"
        alt="Icono de Apple Store"
        class="h-10 w-auto aspect-[27/8]"
        width="108"
        height="32"
        loading="lazy"
      />
    </a>
    <a
      href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
      aria-label="Descargar aplicación desde Google Play"
    >
      <img
        src="/allas-icons/google-play.svg"
        alt="Icono de Google Play"
        class="h-10 w-auto aspect-[27/8]"
        width="108"
        height="32"
        loading="lazy"
      />
    </a>
    <a
      href="https://appgallery.huawei.com/#/app/C115506247"
      aria-label="Descargar aplicación desde Huawei AppGallery"
    >
      <img
        src="/allas-icons/huawei-appgallery.svg"
        alt="Icono de Huawei AppGallery"
        class="h-10 w-auto aspect-[27/8]"
        width="108"
        height="32"
        loading="lazy"
      />
    </a>
  </span>
</ng-template>
